import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { ApplicationService } from '../application/application.service';
import { MessageService } from "../message/message.service";
import { SharedServiceService } from '../shared-service.service';
@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.scss"],
})

export class MessageComponent implements OnInit {

  dataSource: any=[];
  users: any;
  loadershow: boolean;
  selectedApp: any;
  applicationList: any=[];
  applicationList2: any=[];
  arg1: [];
  totalSentMessageLoader = true;
  userData: any;
  developerId: [];  
  currentYearStarts: any = moment();
  currentYearEnds: any = moment();
  todaysCount: number[] = [];
  applicationDetails: any;
  applicationId: string;
  editedApplicationName: string;
  editedApplicationDescription: string;
  isEditApplication = false;
  isEditApplicationDescription = false;
  clickedItem: any;
  addConnectorDetails: [];
  totalSentMessages: number;
  todaysCountLoader = true;
  todaysDate: any = moment();
  currentWeekStarts: any = moment();
  currentWeekEnds: any = moment();
  currentMonthStarts: any = moment();
  currentMonthEnds: any = moment();
  fromDate: any = moment().subtract(30, "days");
  toDate: any = moment();
  currentPage = 1;
  page:number=1;
  paginationDisabled: boolean=false;
  paginationCount:number=0;
  matCategory: any = '';
  items = [];
  pageOfItems: Array<any>;
  search:any;
  paginateData : Array<any>;
  monthlyCountLoader = true;
  Loader = false;
  ageLoader = false;
  arr:any=[];
  d:any=0;
  pageLoader:boolean = true;
  recordNotFound:boolean = false;

  constructor( 
    private http: HttpClient,
    private messageservice: MessageService,
    private sharedService : SharedServiceService,
    private applicationService: ApplicationService
  ) {}

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  displayedColumns: string[] = [
    "applicationName",
    "companyName",
    // "userName",
    // "connectors",
    "projectStartDate",
    "projectRenewalDate",
    "todaysMessage",
    "weeklyMessage",
    "monthlyCount",
    "yearlyCount",
    "totalMessage",
    "totalRenewedMessage",
    "percentage",
    "plan"   
  ];

  ngOnInit() {
    let userData = JSON.parse(localStorage.getItem("user"));
    this.userData = userData;
    this.fromDate = moment(this.fromDate).format("YYYY-MM-DD");
    this.toDate = moment(this.toDate).format("YYYY-MM-DD");
    this.loadershow = true;
    
    if (userData && userData.id) {
      let args = {
        developerId: userData.id
      };
      this.Loader=true;
      this.pageLoader =true;      
      this.getApplicationName(args);      
    }  
  }
  
  public applyFilter(filterValue: string) {   
    this.search = filterValue;
    this.page=1;
    if(filterValue == ""){
      this.arr = this.applicationList;
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      this.recordNotFound=true;
      } else{      
      var data1: any[];
      data1 = this.applicationList.filter(function (ele, i, array) {
        let arrayElementApplicationName = ele.applicationName.toLowerCase();
        let arrayElementCompanyName = ele.companyName.toLowerCase();
        return arrayElementApplicationName.includes(filterValue.toLowerCase()) || arrayElementCompanyName.includes(filterValue.toLowerCase());
      });
        
      this.arr = data1;
      this.sentTodaysCount(this.arr); 
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));       
    }
    this.paginationCount= this.arr.length;  
  }

  getApplicationName(args) {  
    this.messageservice.getApplicationName(args).subscribe((data) => {  
            if(data && data.status)  {
        this.applicationList2 = data.info;   
      this.applicationList2.forEach((element: any) => {
        element.connectorList="";
        element.connectors.map(e =>{
          element.connectorList = element.connectorList ? element.connectorList + ", " + e.name : e.name; 
        })
        element.appSendingLimit = element.appSendingLimit ? element.appSendingLimit : "Nil";
          if(element.companyName !== "-"  && element.companyName !== "" && element.applicationName !== "15RP" && element.applicationName !== "asdasd" && element.applicationName !== "asdasdasdasdasd" && element.applicationName !== "Test1"
          && element.applicationName !== "Test"  && element.applicationName !== "aa" && 
          element.applicationName !== "aa1" && element.applicationName !== "aa_aa" && 
          element.applicationName !== "aaa" && element.applicationName !== "dd" &&
           element.applicationName !== "ddd" && element.applicationName !== "eee" && 
           element.applicationName !== "fsdfd" && element.applicationName !== "hghg" && 
           element.applicationName !== "qqq" && element.applicationName !== "test" && element.applicationName !== "Test App"  && element.applicationName !== "test app" && element.applicationName !== "test1" && element.applicationName !== "test2" && element.applicationName !== "test3" && element.applicationName !== "test4" && element.applicationName !== "test5" && element.applicationName !== "tee" && element.applicationName !== "xxx" && element.applicationName !== "xyzapp" && element.applicationName !== "applll" && element.companyName !== "AMT" && element.companyName !== "amt" && element.companyName !== "aMT" && element.applicationName !== "FirstApplication" && element.applicationName !== "NewApp" && element.applicationName !== "helloworld" && element.applicationName !== "My Test App 1" && element.applicationName !== "koko" && element.applicationName !== "fb" && element.applicationName !== "tw" && element.applicationName !== "TestUnifiedApp" && element.applicationName !== "test_social" && element.applicationName !== "dom" && element.applicationName !== "test exchange" && element.applicationName !== "TestAPP" && element.applicationName !== "TEST" && element.applicationName !== "Just_a_Test" && element.applicationName !== "lili" && element.applicationName !== "testing" && element.applicationName !== "Testing" && element.applicationName !== "HelloWorld" && element.applicationName !== "HelloUE" && element.applicationName !== "test123" && element.applicationName !== "demo" && element.applicationName !== "TestingWhatsAppSandbox" && element.applicationName !== "MyApp" && element.applicationName !== "MM" && element.applicationName !== "First Test" && element.applicationName !== "Trial" && element.applicationName !== "mytest" && element.companyName !== "N/A" && element.companyName !== "n/a" && element.applicationName !== "TestApp" && element.applicationName !== "123" && element.applicationName !== "EmailTest" && element.applicationName !== "SMSTest" && element.applicationName !== "WhatAppTest" && element.applicationName !== "testapp" && element.companyName !== "None" && element.applicationName !== "flx" && element.applicationName !== "25DollarProjects" && element.applicationName !== "wa" && element.applicationName !== "hello" && element.applicationName !== "TEST1" && element.applicationName !== "User_1" && element.applicationName !== "TestPoc"&& element.applicationName !== "qsdqsd" && element.applicationName !== "newapp" && element.applicationName !== "testbot" && element.applicationName !== "boo" && element.applicationName !== "email" && element.applicationName !== "tra" && element.applicationName !== "aqweqweqwe" && element.applicationName !== "sendSMS" && element.applicationName !== "StayPlease" && element.applicationName !== "socialising" && element.applicationName !== "Hello World" && element.applicationName !== "Test app" && element.applicationName !== "My test app" && element.applicationName !== "teste" && element.applicationName !== "deleteME" && element.applicationName !== "social" && element.applicationName !== "first" && element.applicationName !== "huih" && element.applicationName !== "app2" && element.applicationName !== "tmrnd" && element.applicationName !== "teste"  && element.applicationName !== "UEApp"  && element.applicationName !== "UETrial" && element.applicationName !== "TestApp1" && element.applicationName !== "Emytest" && element.applicationName !== "AppBook" && element.applicationName !== "abc" && element.applicationName !== "abc2" && element.applicationName !== "appn" && element.applicationName !== "appn2" && element.applicationName !== "appn3" && element.applicationName !== "Booking" && element.applicationName !== "MyFirstApp" && element.applicationName !== "iotathome" && element.applicationName !== "Emy Test App" && element.applicationName !== "testSocial" ){
              this.applicationList.push(element);
          }
        });    
        this.sentTodaysCount(this.applicationList); 
      this.page = 1;
    }else{
      console.log("no data")
      this.Loader=false;
    }
    },(err)=>{
      console.log("Error op", err);
    });
  }

  sentTodaysCount(subData: []) {
    this.Loader=true;
    if (subData) {   
      const requestData = subData.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10);      
      requestData.forEach((element: any) => {      
        this.todaysDate = moment(this.todaysDate).format("YYYY-MM-DD");
        let arg1 = {
          developerId: element.developerId,
          applicationId: element.applicationId,
          fromDate: this.todaysDate,
          toDate: this.todaysDate,
        };
        this.messageservice.totalSentMsgCount(arg1).subscribe((data) => {
         //   element.count = data && data.status && data.info.totalCount ? data.info.totalCount : 0;          
            if (data && data.status == true) {
              element.count = data.info.totalCount ? data.info.totalCount : 0;
              this.Loader=false;
            }
            else{
              element.count = 0;
            }          
        }); 
     
       this.applicationService.totalReceivedMsgCount(arg1).subscribe((data) => {
         element.countReceviedTodaysMessage = data.info.totalCount ? data.info.totalCount : 0;
       })
        this.currentMonthStarts = moment().startOf("month").format("YYYY-MM-DD");
        this.currentMonthEnds = moment().endOf("month").format("YYYY-MM-DD");
        let args3 = {
          developerId: element.developerId,
          applicationId: element.applicationId,
          fromDate: this.currentMonthStarts,
          toDate: this.currentMonthEnds,
        };
        this.messageservice.totalSentMsgCount(args3).subscribe((data) => {         
            element.countmonthmessage = data && data.info && data.info.totalCount ? data.info.totalCount : 0;
            this.Loader=false;          
        },
       );
       this.applicationService.totalReceivedMsgCount(args3).subscribe((data)=>{
         element.countReceviedMonthMessage = data.info.totalCount ? data.info.totalCount : 0;
       })

       this.currentWeekStarts = moment().startOf("week").format("YYYY-MM-DD");
       this.currentWeekEnds = moment().endOf("week").format("YYYY-MM-DD");
       let args2 = {
         developerId: element.developerId,
         applicationId: element.applicationId,
         fromDate: this.currentWeekStarts,
         toDate: this.currentWeekEnds,
       };
       this.messageservice.totalSentMsgCount(args2).subscribe((data) => {
        
           element.countweekmessage = data && data.info && data.info.totalCount ? data.info.totalCount : 0;
           this.Loader=false;
        
       }
       ); 
          this.applicationService.totalReceivedMsgCount(args2).subscribe((data) => {
            element.countReceivedWeekMessage = data.info.totalCount ? data.info.totalCount : 0;
          })
     

        this.currentYearStarts = moment().startOf("year").format("YYYY-MM-DD");
        this.currentYearEnds = moment().endOf("week").format("YYYY-MM-DD");
        let args4 = {
          developerId: element.developerId,
          applicationId: element.applicationId,
          fromDate: this.currentYearStarts,
          toDate: this.currentYearEnds,
        };
        this.messageservice.totalSentMsgCount(args4).subscribe((data) => {
         
            element.countyearmessage = data && data.status && data.info.totalCount ? data.info.totalCount : 0;
            this.Loader=false;
        });

        this.applicationService.totalReceivedMsgCount(args4).subscribe((data) =>{
          element.countReceivedYearMessage = data.info.totalCount ?  data.info.totalCount : 0;
        })


        
        let args5 = {
          developerId: element.developerId,
          applicationId: element.applicationId,
        };
        this.messageservice.totalSentMsgCount(args5).subscribe(
          (data) => {
            
              element.counttotalmessage = data && data.status && data.info.totalCount ? data.info.totalCount : 0;
              this.Loader=false;
            }
          
        );

        this.messageservice.totalSentMsgPercentage(args5).subscribe((data) => {  
            element.sentPercentage = data && data.status && data.info[0].percentage ? data.info[0].percentage : 0;
            this.Loader = false;
          }          
        );

        this.applicationService.totalReceivedMsgCount(args5).subscribe(
          (data) => {
            
              element.countReceivedTotalMessage = data.info.totalCount ? data.info.totalCount : 0;
              this.Loader=false;
            }
          
        );


        let args6 = {
          developerId: element.developerId,
          applicationId: element.applicationId,
          fromDate: moment(element.lastRenewedAt).format('YYYY-MM-DD'),
			    toDate: moment().format('YYYY-MM-DD')
        };
        this.messageservice.totalSentMsgCount(args6).subscribe(
          (data) => {            
              element.countrenewedtotalmessage = data && data.status && data.info.totalCount ? data.info.totalCount : 0;
              this.Loader=false;
            }
          
        );

        this.applicationService.totalReceivedMsgCount(args6).subscribe(
          (data) => {            
              element.countrenewedReceivedTotalMessage = data.info.totalCount ? data.info.totalCount : 0;
              this.Loader=false;
            }
          
        );

      });

      this.arr = subData;
      // this.dataSource = new MatTableDataSource(this.arr.slice(0,10));
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      this.recordNotFound=true;
     
      setTimeout(()=>{ 
      
        }, 1000);

        this.pageLoader=false;
      this.paginationCount = this.arr.length;
     
    }
  }

  viewApplicationDetails(item) {
    this.isEditApplication = false;
    this.isEditApplicationDescription = false;
    this.loadershow = true;
    if (item) {
      this.clickedItem = item;
      localStorage.setItem("appDetails", JSON.stringify(item));
    }

    let args = {
      developerId: this.userData.id,
      applicationId: item ? item.id : "",
    };
    if (item) {
      this.messageservice.getApplicationName(args);
      this.getConnectorDetails(args);
    } else {
      this.loadershow = false;
    }
  }

  getConnectorDetails(args) {
    this.messageservice.getConnectorDetails(args).subscribe((data) => {
      if (data) {
        this.addConnectorDetails = data.info;
      }
    });
  }

  async getConnectorsList() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
    };

    return await this.messageservice.getConnectorsList(args).toPromise();
  }

  pageChanged2(page){
    this.sentTodaysCount(this.arr); 
     this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      
    }
    MyFunctionApplicationName(element: any){
      
      this.sharedService.applicationNamePass = element;
      
    }
   
}
